import React from 'react';

// Zola Helpers
import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';

// Zola-UI Components
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

// Redux
import { useAppSelector } from 'reducers/useAppSelector';
import { useAppDispatch } from 'reducers/useAppDispatch';
import { quickAddProjectToCart } from 'cards/actions/project/addToCart';
import { customizeCard } from 'cards/reducers/pdp/actions';
import { getIsAdminView } from 'cards/selectors/cardCatalogSelector';
import { getProjectState } from 'cards/selectors/cardProjectSelector';

interface QuickAddToCartCTAProps {
  activeColor: string;
  card: any;
}

export const QuickAddToCartCTA: React.FC<QuickAddToCartCTAProps> = ({ activeColor, card }) => {
  const dispatch = useAppDispatch();

  const isAdminView = useAppSelector(getIsAdminView);
  const project = useAppSelector(getProjectState);

  const { customizationTypeToUUID, entities, type } = project;
  const customizationUuid = type ? customizationTypeToUUID?.[type] : undefined;
  const customization = customizationUuid
    ? entities?.customizations?.[customizationUuid]
    : undefined;
  const { quantity = 20 } = customization || {};

  const activeVariation = card.colors.find((color: any) => color.value === activeColor);

  const { default_variation_uuid: activeVariationUUID } = activeVariation;
  const { suiteUUID: activeSuiteUUID } = card;

  const createProject = () => {
    if (!activeVariation) {
      return dispatch(toastsActions.negative({ headline: 'Unable to add to cart' }));
    }

    return dispatch(
      customizeCard(
        activeSuiteUUID,
        activeVariationUUID,
        quantity,
        isAdminView,
        true,
        undefined,
        false,
        null,
        false
      )
    ).then(result => {
      const { uuid: projectUUID } = result;

      dispatch(quickAddProjectToCart(projectUUID)).catch(() => undefined);
    });
  };

  return <ButtonV3 onClick={createProject}>Add {quantity} to cart</ButtonV3>;
};
